import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PaymentAdd from "./tabs/PaymentAdd";
import { Wrapper } from "../styled";

const additionalPaymentTabs = [
{
    title: "Доплаты",
    component: <PaymentAdd/>,
}
];

const AdditionalPayment: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {additionalPaymentTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {additionalPaymentTabs[tab].component}
    </Wrapper>
);
};

export default AdditionalPayment;
